module.exports = __webpack_public_path__ + "./img/src/img/cases/luissimoes/casesocial_media-copy.png";